module.exports = __webpack_public_path__ + "static/media/folder.ea97979f.svg";